import type { KBIconName } from '../components/KBIcons'

export interface KBSection {
  id: string
  title: string
  icon: KBIconName
  subsections: { id: string; title: string }[]
}

export const MANAGER_SECTIONS: KBSection[] = [
  {
    id: 'dashboard',
    title: 'Дашборд',
    icon: 'dashboard',
    subsections: [
      { id: 'dashboard-overview', title: 'Обзор' },
      { id: 'dashboard-kpi', title: 'KPI-карточки' },
      { id: 'dashboard-funnel', title: 'Воронка продаж' },
      { id: 'dashboard-events', title: 'Лента событий' },
    ],
  },
  {
    id: 'notifications',
    title: 'Уведомления',
    icon: 'bell',
    subsections: [
      { id: 'notifications-bell', title: 'Колокольчик в шапке' },
      { id: 'notifications-feed', title: 'Лента уведомлений' },
      { id: 'notifications-types', title: 'Типы событий' },
      { id: 'notifications-mentions', title: '@-упоминания' },
      { id: 'notifications-news', title: 'Лента новостей' },
    ],
  },
  {
    id: 'clients',
    title: 'Клиенты',
    icon: 'clients',
    subsections: [
      { id: 'clients-list', title: 'Список клиентов' },
      { id: 'clients-new', title: 'Новый клиент' },
      { id: 'clients-detail', title: 'Карточка клиента' },
      { id: 'clients-inn', title: 'Проверка ИНН' },
    ],
  },
  {
    id: 'requests',
    title: 'Заявки',
    icon: 'requests',
    subsections: [
      { id: 'requests-list', title: 'Список заявок' },
      { id: 'requests-new', title: 'Создание заявки' },
      { id: 'requests-detail', title: 'Страница заявки' },
      { id: 'requests-statuses', title: 'Статусы заявок' },
      { id: 'requests-items', title: 'Позиции заявки' },
      { id: 'requests-assign', title: 'Назначение закупщика' },
    ],
  },
  {
    id: 'procurement-requests',
    title: 'Запросы поставщикам',
    icon: 'mail',
    subsections: [
      { id: 'procurement-requests-overview', title: 'Обзор модуля' },
      { id: 'procurement-requests-create', title: 'Создание запроса' },
      { id: 'procurement-requests-import', title: 'Импорт ответа' },
    ],
  },
  {
    id: 'kp',
    title: 'Коммерческое предложение',
    icon: 'kp',
    subsections: [
      { id: 'kp-mode', title: 'Режим КП' },
      { id: 'kp-prices', title: 'Выбор цен' },
      { id: 'kp-quotes-selection', title: 'Страница выбора квот' },
      { id: 'kp-markup', title: 'Наценки' },
      { id: 'kp-preview', title: 'Предпросмотр КП' },
      { id: 'kp-export', title: 'Генерация Excel' },
    ],
  },
  {
    id: 'orders',
    title: 'Заказы',
    icon: 'orders',
    subsections: [
      { id: 'orders-overview', title: 'Обзор и статусы заказа' },
      { id: 'orders-invoices-payments', title: 'Счета и оплаты' },
      { id: 'orders-documents-history', title: 'Документы и история' },
      { id: 'orders-roles-approval', title: 'Роли и согласование РОП' },
    ],
  },
  {
    id: 'catalog',
    title: 'Каталог и «Наименование»',
    icon: 'catalog',
    subsections: [
      { id: 'catalog-overview', title: 'Раздел «Каталог»' },
      { id: 'catalog-naming', title: '«Наименование» позиции' },
      { id: 'catalog-learning', title: 'Самообучение' },
      { id: 'catalog-unf-export', title: 'Выгрузка в УНФ и дубли' },
    ],
  },
  {
    id: 'table',
    title: 'Таблица',
    icon: 'table',
    subsections: [
      { id: 'table-overview', title: 'Обзор таблицы' },
      { id: 'table-filters', title: 'Фильтры и поиск' },
      { id: 'table-groups', title: 'Группировка по заявкам' },
      { id: 'table-columns', title: 'Настройка колонок' },
    ],
  },
  {
    id: 'settings',
    title: 'Настройки',
    icon: 'settings',
    subsections: [{ id: 'settings-account', title: 'Настройки аккаунта' }],
  },
]

export const PROCUREMENT_SECTIONS: KBSection[] = [
  {
    id: 'proc-dashboard',
    title: 'Дашборд',
    icon: 'dashboard',
    subsections: [
      { id: 'proc-dashboard-overview', title: 'Обзор' },
      { id: 'proc-dashboard-stats', title: 'Статистика квот' },
    ],
  },
  {
    id: 'proc-queue',
    title: 'Очередь квот',
    icon: 'queue',
    subsections: [
      { id: 'proc-queue-overview', title: 'Обзор очереди' },
      { id: 'proc-queue-filters', title: 'Фильтры' },
      { id: 'proc-queue-state', title: 'Состояния позиций' },
      { id: 'proc-queue-take', title: 'Excel-workflow' },
      { id: 'proc-queue-completion', title: 'Закупка завершена' },
      { id: 'proc-queue-manufacturer', title: 'Запрос производителю' },
      { id: 'proc-queue-hide', title: 'Скрытие позиций' },
    ],
  },
  {
    id: 'proc-requests',
    title: 'Заявки',
    icon: 'requests',
    subsections: [
      { id: 'proc-requests-list', title: 'Список заявок' },
      { id: 'proc-requests-detail', title: 'Страница заявки' },
      { id: 'proc-requests-notes', title: 'Заметки в таблице' },
    ],
  },
  {
    id: 'proc-quotes',
    title: 'Квоты',
    icon: 'quotes',
    subsections: [
      { id: 'proc-quotes-create', title: 'Создание квоты' },
      { id: 'proc-quotes-edit', title: 'Редактирование' },
    ],
  },
  {
    id: 'suppliers',
    title: 'Поставщики',
    icon: 'suppliers',
    subsections: [
      { id: 'suppliers-overview', title: 'Справочник поставщиков' },
      { id: 'suppliers-card', title: 'Карточка поставщика' },
      { id: 'suppliers-cleanup', title: 'Чистка справочника' },
      { id: 'suppliers-merge', title: 'Объединение дублей' },
      { id: 'suppliers-import', title: 'Автопополнение и импорт' },
    ],
  },
]

// Аналитика и планирование — руководительские разделы: ADMIN/ГД видят всё,
// РОП получает оба, РОЗ — аналитику (паритет с доступом в самих разделах).
export const ANALYTICS_SECTION: KBSection = {
  id: 'analytics',
  title: 'Аналитика',
  icon: 'analytics',
  subsections: [
    { id: 'analytics-overview', title: 'Обзор раздела' },
    { id: 'analytics-summary', title: 'Сводка' },
    { id: 'analytics-people-tabs', title: 'Менеджеры, клиенты, закупщики, поставщики' },
    { id: 'analytics-kp-timeline', title: 'КП-таймлайн и история заявки' },
  ],
}

export const PLANNING_SECTION: KBSection = {
  id: 'planning',
  title: 'Планирование',
  icon: 'planning',
  subsections: [
    { id: 'planning-plan-fact-table', title: 'Таблица план/факт' },
    { id: 'planning-akb', title: 'АКБ' },
    { id: 'planning-rating', title: 'Рейтинг на дашборде' },
  ],
}

export const ADMIN_EXTRA_SECTIONS: KBSection[] = [
  ANALYTICS_SECTION,
  PLANNING_SECTION,
  {
    id: 'admin-roles',
    title: 'Роли и доступ',
    icon: 'roles',
    subsections: [
      { id: 'admin-roles-overview', title: 'Обзор ролей' },
      { id: 'admin-roles-rop-ros', title: 'РОП и РОЗ' },
      { id: 'admin-roles-cities', title: 'Города и видимость' },
    ],
  },
  {
    id: 'admin-accounts',
    title: 'Управление аккаунтами',
    icon: 'accounts',
    subsections: [
      { id: 'admin-accounts-list', title: 'Список пользователей' },
      { id: 'admin-accounts-create', title: 'Создание аккаунта' },
    ],
  },
  {
    id: 'admin-rates',
    title: 'Курсы валют',
    icon: 'rates',
    subsections: [
      { id: 'admin-rates-edit', title: 'Редактирование курсов' },
      { id: 'admin-rates-markup', title: 'Константы наценки' },
    ],
  },
  {
    id: 'admin-catalog',
    title: 'Каталог партномеров',
    icon: 'catalog',
    subsections: [
      { id: 'admin-catalog-overview', title: 'Обзор каталога' },
      { id: 'admin-catalog-import', title: 'Импорт Excel' },
    ],
  },
]

export function getSectionsForRole(role: string): KBSection[] {
  // ГД — просмотр всей системы, база знаний как у админа.
  if (role === 'ADMIN' || role === 'GENERAL_DIRECTOR') {
    return [...MANAGER_SECTIONS, ...PROCUREMENT_SECTIONS, ...ADMIN_EXTRA_SECTIONS]
  }
  // РОП — менеджерские разделы + руководительские (аналитика, планирование).
  if (role === 'ROP') return [...MANAGER_SECTIONS, ANALYTICS_SECTION, PLANNING_SECTION]
  // РОЗ — закупочные разделы (включая «Поставщики») + аналитика.
  if (role === 'ROS') return [...PROCUREMENT_SECTIONS, ANALYTICS_SECTION]
  if (role === 'PROCUREMENT') return PROCUREMENT_SECTIONS
  // MANAGER и ASSISTANT (работает как менеджер в рамках своих менеджеров).
  return MANAGER_SECTIONS
}
